import { SaveSession } from "../../../../connection/create-event";
import { GetSessionsForEvent } from "../../../../connection/sessions";
import { Action, AsyncAction } from "../../../../types/actions";
import {
	CreateVideo,
	HomepageVideo,
	PageModule,
	PageModuleGroupModules,
	PageModuleType,
	Session,
	SessionLayout,
	SessionVideoCustomizations,
} from "../../../../types/working-model";

export const LOAD_WORKING_SESSION = "LOAD_WORKING_SESSION";
export function loadWorkingSession(session: Session | null): Action {
	return {
		type: LOAD_WORKING_SESSION,
		payload: session
	};
}

export const CLEAR_WORKING_SESSION = "CLEAR_WORKING_SESSION";
export function clearWorkingSession(): Action {
	return {
		type: CLEAR_WORKING_SESSION,
		payload: null
	};
}

export const TOGGLE_PAGE_MODULE = "TOGGLE_PAGE_MODULE";
export function togglePageModule(module: PageModule): Action {
	return {
		type: TOGGLE_PAGE_MODULE,
		payload: module
	};
}

export const UPDATE_PAGE_MODULE = "UPDATE_PAGE_MODULE";
export function updatePageModule(module: PageModule): Action {
	return {
		type: UPDATE_PAGE_MODULE,
		payload: module
	};
}

export const SET_SESSION_LAYOUT = "SET_SESSION_LAYOUT";
export function setSessionLayout(options: SessionLayout): Action {
	return {
		type: SET_SESSION_LAYOUT,
		payload: options
	};
}

export const SET_SESSION_MODULES = "SET_SESSION_MODULES";
export function setSessionModules(modules: PageModule[]): Action {
	return {
		type: SET_SESSION_MODULES,
		payload: modules
	};
}

export const ADD_SESSION_PAGE_MODULE = "ADD_SESSION_PAGE_MODULE";
export function addSessionPageModule(page_module: PageModule): Action {
	return {
		type: ADD_SESSION_PAGE_MODULE,
		payload: page_module
	};
}

export const SET_SESSION_ACTIVE_MODULE = "SET_SESSION_ACTIVE_MODULE";
export function setSessionActiveModule(selected: PageModuleType): Action {
	return {
		type: SET_SESSION_ACTIVE_MODULE,
		payload: selected
	};
}

export const SET_SESSION_ACTIVE_MODULE_BY_ID = "SET_SESSION_ACTIVE_MODULE_BY_ID";
export function setSessionActiveModuleById(moduleId: number | null): Action {
	return {
		type: SET_SESSION_ACTIVE_MODULE_BY_ID,
		payload: moduleId
	};
}

export const SET_ACTIVE_SESSION_GROUP_MODULE = "SET_ACTIVE_SESSION_GROUP_MODULE";
export function setActiveSessionGroupModule(moduleGroupUuid: string | null): Action {
	return {
		type: SET_ACTIVE_SESSION_GROUP_MODULE,
		payload: moduleGroupUuid
	};
}

export const SET_SESSION_USE_NAV = "SET_SESSION_USE_NAV";
export function setSessionUseNav(useNav: boolean): Action {
	return {
		type: SET_SESSION_USE_NAV,
		payload: useNav
	};
}

export const GET_SESSIONS_FOR_EVENT = "GET_SESSIONS_FOR_EVENT";
export function getSessionsForEvent(token: string, uuid: string): AsyncAction {
	return {
		type: GET_SESSIONS_FOR_EVENT,
		promise: GetSessionsForEvent(token, uuid)
	};
}

export const UPDATE_SESSION = "UPDATE_SESSION";
export function updateSession(session: Session, token: string): AsyncAction {
	return {
		type: UPDATE_SESSION,
		promise: SaveSession(session, token),
	};
}

export const UPDATE_WORKING_SESSION = "UPDATE_WORKING_SESSION";
export function updateWorkingSession(session: Session): Action {
	return {
		type: UPDATE_WORKING_SESSION,
		payload: session,
	};
}

export const UPDATING_SESSION = "UPDATING_SESSION";
export function updatingSession(isUpdating: boolean): Action {
	return {
		type: UPDATING_SESSION,
		payload: isUpdating,
	};
}

export const UPDATE_MODULE_GROUPINGS = "UPDATE_MODULE_GROUPINGS";
export function updateGroupModules(moduleGroupings: PageModuleGroupModules): Action {
	return {
		type: UPDATE_MODULE_GROUPINGS,
		payload: moduleGroupings,
	};
}

export const SET_ON_DEMAND_VIDEO = "SET_ON_DEMAND_VIDEO";
export function setOnDemandVideo(video: CreateVideo | HomepageVideo): Action {
	return {
		type: SET_ON_DEMAND_VIDEO,
		payload: video
	};
}

export const SET_SESSION_BROADCAST_TYPE = "SET_SESSION_BROADCAST_TYPE";
export function setSessionBroadcastType(type: 'greenroom' | 'rtmps'): Action {
	return {
		type: SET_SESSION_BROADCAST_TYPE,
		payload: type
	};
}

export const SET_VIDEO_CUSTOMIZATIONS = "SET_VIDEO_CUSTOMIZATIONS";
export function setVideoCustomizations(customizations: SessionVideoCustomizations): Action {
	return {
		type: SET_VIDEO_CUSTOMIZATIONS,
		payload: customizations
	};
}

export const UPDATE_MODERATION_SETTINGS = "UPDATE_MODERATION_SETTINGS";
export function updateModerationSettings(settings: {
	posts: boolean;
	questions: boolean;
	chat: boolean;
}): Action {
	return {
		type: UPDATE_MODERATION_SETTINGS,
		payload: settings
	};
}

export const SET_SESSION_CSS = "SET_SESSION_CSS";
export function setSessionCss(css: string): Action {
	return {
		type: SET_SESSION_CSS,
		payload: css
	};
}

export const REMOVE_SESSION_FROM_CREATE_SESSION = 'REMOVE_SESSION_FROM_CREATE_SESSION';
export function removeSessionFromCreateSessionReducer(sessionID: number, eventUuid: string): Action {
	return {
		type: REMOVE_SESSION_FROM_CREATE_SESSION,
		payload: { sessionID, eventUuid },
	};
}
